import { useCallback } from 'react';
import { useRouter } from 'next/navigation';

// utils
import { generateDealerUrl } from '../utils/generate-dealer-url';
import { useLocatorConfiguration } from '../utils/use-locator-configuration';
import { useContent } from 'components/Page/page-hooks';
import { useTracking } from 'utils/tracking/track';

export function useGoToDealerPage() {
  const locatorConfig = useLocatorConfiguration();
  const content = useContent();
  const locale = content?.metaData?.lang?.slice(0, 2).toLowerCase();
  const router = useRouter();
  const { trackLocator } = useTracking();

  return useCallback(
    (dealer: { name: string; city: string }) => {
      let dealerPageUrl = `${locatorConfig.url}/${generateDealerUrl(dealer, locale)}`;
      dealerPageUrl = dealerPageUrl.replace(/\/\//, '/');

      router.push(
        `${dealerPageUrl}${
          window.location.search ? `?_search=${encodeURIComponent(window.location.search)}` : ''
        }`,
      );
      trackLocator({
        click_intent: 'locator dealer more details',
        search_term: dealer.name,
        value: 5,
        content_type: 'locator-partner',
      });
    },
    [locatorConfig.url, locale, router, trackLocator],
  );
}
